import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

export const Field = ({ label, value, onChange, testId, hint, ...props }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    <Input value={value || ''} onChange={(e) => onChange(e.target.value)} className="mt-1" data-testid={testId} {...props} />
    {hint && <p className="text-xs text-neutral-500 mt-1">{hint}</p>}
  </div>
);

export const Section = ({ title, children, testId }) => (
  <div className="bg-white border rounded-lg p-5 space-y-3" data-testid={testId}>
    <p className="font-semibold">{title}</p>
    {children}
  </div>
);
